import { mat4 } from 'gl-matrix';
import { DcmJsDatasetWrapper } from './dcmJsWrapper';
import { DicomRegistration } from './dicomRegistration';
import { mat4ToRowMajorArray } from './utils';

export class DicomRigidRegistration extends DicomRegistration {
    public readonly transformation: mat4;

    constructor(
        sopUid: string,
        sourceFrameOfReferenceUid: string,
        targetFrameOfReferenceUid: string,
        contentLabel: string,
        transformation: mat4,
        dataset: DcmJsDatasetWrapper
    ) {
        super(
            sopUid,
            sourceFrameOfReferenceUid,
            targetFrameOfReferenceUid,
            contentLabel,
            dataset
        );
        this.transformation = transformation;
    }

    /**
     * Syncs the current transformation mat4 back into the
     * underlying DICOM dataset so that getAsDicomBlob()
     * serializes the up-to-date matrix.
     */
    public syncTransformationToDataset(): void {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const ds = this.datasetWrapper.dataset as any;
        if (!ds?.RegistrationSequence) {
            return;
        }

        for (const entry of ds.RegistrationSequence) {
            if (entry.FrameOfReferenceUID === this.targetFrameOfReferenceUid) {
                entry.MatrixRegistrationSequence.MatrixSequence.FrameOfReferenceTransformationMatrix =
                    mat4ToRowMajorArray(this.transformation);
                return;
            }
        }
    }
}
